import axios from "axios";

export const ACTION_FETCH_CLIENT_LIST_PENDING = 'ACTION_FETCH_CLIENT_LIST_PENDING';
export const ACTION_FETCH_CLIENT_LIST_SUCCESS = 'ACTION_FETCH_CLIENT_LIST_SUCCESS';
export const ACTION_FETCH_CLIENT_LIST_ERROR = 'ACTION_FETCH_CLIENT_LIST_ERROR';

function fetchClientListPending(clientListFilter) {
    return {
        type: ACTION_FETCH_CLIENT_LIST_PENDING,
        clientListFilter: clientListFilter
    }
}

function fetchClientListSuccess(clientList) {
    return {
        type: ACTION_FETCH_CLIENT_LIST_SUCCESS,
        clientList: clientList
    }
}

function fetchClientListError(clientListError) {
    return {
        type: ACTION_FETCH_CLIENT_LIST_ERROR,
        clientListError: clientListError
    }
}

function fetchClientListAction(filter, dispatchFilter) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Client/Search';
    return dispatch => {
        if (dispatchFilter) {
            dispatch(fetchClientListPending(filter));
        }
        axios.post(url, filter, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchClientListSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchClientListError(error));
            })
    }
}

export default fetchClientListAction;
